import jexl from 'jexl';

import { DataObject, DataObjectValueType } from '../../api';

export const anyMatch = (items: DataObjectValueType[], predicate: string, variables: DataObject = {}): boolean => {
  if (!Array.isArray(items)) {
    return false;
  }

  for (const item of items) {
    const context = { ...variables, it: item };
    const result = jexl.evalSync(predicate, context);
    if (result === true) {
      return true;
    }
  }

  return false;
};
